'use strict';

import React, { Component } from 'react'

import DataHeader from '@Pure/DataHeader'
import SearchBar  from '@Pure/SearchBar'
import DataRow    from '@Pure/DataRow'
import Loader     from '@Pure/Loader'
import Image      from '@Pure/Image'
import Link       from '@Pure/Link'

const { app, qwest } = window;

export default class DataList extends Component
{
	state =
	{
		data: [],

		references: [],

		searched:
		{
			value: ''
		},

		pagination:
		{
			max_items: this.props['max-items'] || 30,
			limit: this.props['max-items'] || 30,
			skip: 0
		},

		sort_order: this.props.default_sort_order,
		sort_field: this.props.default_sort_field,

		custom_filters: { }
	};

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		if (props.onMount)
		{
			props.onMount(this);
		}

		component.fetchData(
		{
			sort_order: props.default_sort_order,
			sort_field: props.default_sort_field
		});

		app.push(
		{
			event: 'DataList__filterChange',
			cb: component.handleFilterChange
		});

		app.push(
		{
			event: 'DataList__requestRefresh',
			cb: component.requestRefresh
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'DataList__filterChange',
			cb: component.handleFilterChange
		});

		app.delete(
		{
			event: 'DataList__requestRefresh',
			cb: component.requestRefresh
		});
	}

	requestRefresh = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		if (data.id !== props.id) return;

		component.fetchData({ });
	}

	handleFilterChange = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		if (data.id !== props.id) return;

		component.setState(
		{
			custom_filters:
			{
				...(data.filter || { })
			},

			pagination:
			{
				...state.pagination,

				limit: 30,
				skip: 0
			}
		});

		component.fetchData(
		{
			query:
			{
				...(props.config.filter_query || { }),

				...(data.filter || { })
			}
		});
	}

	fetchData = ({ query, sort_order, sort_field }) =>
	{
		const component = this, props = this.props, state = this.state;

		const config = props.config

		if (props.data) return;

		let filter_query = query || config.filter_query;

		if (filter_query)
		{
			if (!query)
			{
				filter_query = { ...filter_query, ...state.custom_filters };
			}
		}

		if (filter_query)
		{
			if (sort_order && sort_field)
			{
				filter_query.sort = sort_field + ' ' + sort_order
			}
			else if (state.sort_order && state.sort_field)
			{
				filter_query.sort = state.sort_field + ' ' + state.sort_order
			}
		}
		else if (state.sort_order && state.sort_field)
		{
			filter_query.sort = state.sort_field + ' ' + state.sort_order
		}

		component.setState(
		{
			loading: true
		});

		component.setState({ loading: true });

		qwest.post(props.fetch ? '/fetch/all' : '/CMS/getAll',
		{
			model: config.model,

			true_pagination: props['true-pagination'] === true,

			filter_query: filter_query
			? JSON.stringify(filter_query)
			: undefined
		})
		.then(function (xhr, response)
		{
			if (typeof config.hookFetch === 'function')
			{
				response = config.hookFetch(
				{
					response: response,
					filter_query: filter_query
				});
			}

			component.setState(
			{
				loading: false,
				data: response.data || [],
				references: response.references || []
			});
		})
		.catch(function (error, xhr, response)
		{
			console.error(response?.error || response?.raw || error);

			component.setState({ loading: false });

			app.ajaxRedirectLogin(response);
		});
	}

	handleSearch = (value, search) =>
	{
		const component = this, props = this.props;

		component.setState(
		{
			searched:
			{
				value: value || '',
				data: search && search.data
				? (search.data.value ? search.data : { ...search.data, value: '' })
				: undefined
			}
		});

		app.emit('searchChange');
	}

	getPagination = () =>
	{
		const component = this, props = this.props, config = this.props.config;

		let limit     = this.state.pagination.limit, skip = this.state.pagination.skip;
		let max_items = this.state.pagination.max_items;

		let total_items = component.state.data.length;

		let pagination = [];

		for (let i = 0; i < total_items; i += max_items)
		{
			let data =
			{
				items_count: (i + max_items > total_items) ? (total_items - i) : (max_items),
				skip: i
			};

			data.limit = i + data.items_count;

			pagination.push(data);
		}

		pagination = pagination.map(function (data, index)
		{
			let is_active = component.state.pagination.limit === data.limit;

			let output =
			(
				<div key={ index } className={ 'c-pagination-item' +
					(is_active ? ' c-pagination-item--active' : '') }
					onClick={ function () { setPagination(data); } }>
					{ index + 1 }
				</div>
			);

			return output;
		});

		return pagination;

		function setPagination (data)
		{
			let pagination = Object.assign({ }, component.state.pagination);

			pagination.limit = data.limit;
			pagination.skip  = data.skip;

			component.setState({ pagination: pagination });
		}
	}

	handleSort = ({ fieldname }) =>
	{
		const component = this, props = this.props, state = this.state;

		if (state.loading === true) return;

		const config = props.config;

		const sort_order = state.sort_field === fieldname
		? (state.sort_order === 'DESC' ? 'ASC' : 'DESC')
		: 'ASC';

		component.setState(
		{
			sort_field: fieldname,

			sort_order: sort_order
		});

		let filter_query =
		{
			...(config.filter_query || { })
		};

		component.fetchData(
		{
			query: filter_query,
			sort_field: fieldname,
			sort_order: sort_order
		});
	}

	render ()
	{
		const component = this, props = this.props, config = this.props.config;
		const state = this.state;

		var loader, searched_words, autocomplete_data = [], displayed_fields = { };

		Object.keys(config.header_map).forEach(function (column)
		{
			displayed_fields[column] = true;
		});

		if (props.data)
		{
			state.data = props.data;
			state.references = props.references || [];
		}

		if (component.state.loading === true)
		{
			loader =
			(
				<Loader className="c-loader"
					bemit={ ['primary', 'bg-light', 'medium', 'DataList'] } />
			);
		}

		if (component.state.searched.data)
		{
			searched_words = component.state.searched.data.value.split(' ');
		}
		else
		{
			searched_words = component.state.searched.value.split(' ');
		}

		let pagination = component.getPagination();

		if (props.pagination === false || pagination)
		{
			if (props.pagination === false || pagination.length <= 1 ||
				state.searched.value !== '')
			{
				pagination = undefined;
			}
		}

		let data = component.state.data;

		if (typeof config.sort === 'function' === false && config.fields &&
			!config.sortable_cols)
		{
			let filter_prop = config.fields.name ? 'name' : 'label';

			if (config.fields[filter_prop])
			{
				data = data.sort(function (a, b)
				{
					return a[filter_prop].toLowerCase()
					.localeCompare(b[filter_prop].toLowerCase());
				});
			}
		}

		data = data
		.filter(function (element)
		{
			var match = false;

			let value;

			if (config.searched_prop instanceof Array)
			{
				value = { };

				config.searched_prop.forEach(function (field)
				{
					let field_split = field.split('.');

					let prop_value;

					if (config.fields[field_split[0]] &&
						config.fields[field_split[0]].reference instanceof Object)
					{
						let reference = config.fields[field_split[0]].reference;

						let referenced_data = component.state.references
						.find(infos => infos.model === reference.model);

						referenced_data = (referenced_data || { data: [] }).data.map(infos => infos);

						let ref_field = referenced_data
						.find(data => element[field_split[0]] === data.id);

						prop_value = ref_field || { };
					}
					else
					{
						prop_value = element[field_split[0]];
					}

					for (var i = 1; i < field_split.length; i++)
					{
						if (!prop_value[field_split[i]])
						{
							prop_value = undefined;
							break;
						}

						prop_value = prop_value[field_split[i]];
					}

					if (prop_value) value[field] = prop_value;
				});

			}
			else
			{
				value = element[config.searched_prop];
			}

			autocomplete_data.push(
			{
				value: value || '',
				id: element.id
			});

			if (component.state.searched.data)
			{
				if (element.id === component.state.searched.data.id)
				{
					match = true;
				}
			}
			else
			{
				searched_words.find(function (word)
				{
					let find;

					if (config.searched_prop instanceof Array)
					{
						find = config.searched_prop.find(function (field_pattern)
						{
							let field_split = field_pattern.split('.');

							let prop_value = element[field_split[0]];

							if (config.fields[field_split[0]] &&
								config.fields[field_split[0]].reference instanceof Object)
							{
								let reference = config.fields[field_split[0]].reference;

								let referenced_data = component.state.references
								.find(infos => infos.model === reference.model);

								referenced_data = (referenced_data || { data: [] }).data.map(infos => infos);

								let ref_field = referenced_data
								.find(data => element[field_split[0]] === data.id);

								prop_value = ref_field || { };
							}

							for (var i = 1; i < field_split.length; i++)
							{
								if (!prop_value[field_split[i]])
								{
									prop_value = undefined;
									break;
								}

								prop_value = prop_value[field_split[i]];
							}

							if (!prop_value)
							{
								return false;
							}
							else if (prop_value.toLowerCase().indexOf(word.toLowerCase()) !== -1)
							{
								return true;
							}
						});

						if (find)
						{
							match = true;
							return true;
						}
					}
					else if (element[config.searched_prop].toLowerCase().indexOf(word.toLowerCase()) !== -1)
					{
						match = true;
						return true;
					}
				});
			}

			return match;
		});

		if (config.sort instanceof Function && !config.sortable_cols)
		{
			data = config.sort(data);
		}

		data = data.filter(function (element, index)
		{
			if (component.state.searched.value.length > 1 || props.pagination === false)
			{
				return true;
			}

			return index < state.pagination.limit && index >= state.pagination.skip;
		})
		.map(function (element)
		{
		/**
		 * For each field, check if it is a reference to an other model and if it is the case,
		 * change its value to match the referenced field.
		 **/
			Object.keys(element || { })
			.filter(function (field_name)
			{
				if (config.fields && config.fields[field_name] && config.fields[field_name].reference)
				{
					return true;
				}

				return false;
			})
			.forEach(function (field_name)
			{
				let reference = config.fields[field_name].reference;

				let referenced_data = component.state.references
				.find(infos => infos.model === reference.model);

				referenced_data = (referenced_data || { data: [] }).data.map(infos => infos);

				let id = element[field_name] instanceof Array ? element[field_name][0] :
					element[field_name];

				let ref_field = referenced_data
				.find(data => id === data.id);

				if (ref_field)
				{
					element[field_name] = ref_field[reference.referenced_field.name];
				}
			});

			return element;
		});

		data = data.map(function (element, i)
		{
			var image_fields = config.image_fields instanceof Array
			? config.image_fields
			: [];

			var date_fields = config.date_fields instanceof Array
			? config.date_fields
			: [];

			var field_hook = config.field_hook instanceof Object
			? config.field_hook
			: { };

			var data = { };

			Object.keys(config.header_map).forEach(function (column)
			{
				var mapped_props = config.header_map[column].split('.');

				var value = element;

				var is_hooked = field_hook[column] instanceof Function;

				mapped_props.forEach(function (property)
				{
					if (value instanceof Object === true)
					{
						value = value[property];
					}

					if (typeof value === 'undefined')
					{
						value = '';

						return;
					}

					if (value instanceof Array)
					{
						value = value[0];
					}
				});

				if (is_hooked === true)
				{
					value = field_hook[column](value, element, component);
				}

				if (date_fields.indexOf(column) !== -1 && is_hooked === false)
				{
					value = window.moment(value).format('D MMM YYYY');
				}

				if ( (config.html_fields || []).find(name => column === name) )
				{
					value = value.split('<br>').join('');
					value = value.split('<p></p>').join('');

					value =
					(
						<span className="c-rendered-text" dangerouslySetInnerHTML={
							{ __html: app.truncateToLength(value, 130, '') } } />
					);
				}

				if (image_fields.indexOf(column) !== -1 && is_hooked === false && value)
				{
					let link;

					if (config.row_link_base)
					{
						link =
						(
							<Link className="u-link-only"
								target={ config.prevent_blank ? undefined : '_blank' }
								href={ config.row_link_base + element.id } />
						);
					}
					else if (config.onClick instanceof Function)
					{
						link =
						(
							<button className="u-link-only"
								onClick={ function (e) { config.onClick(e, element); } }></button>
						);
					}

					data[column] =
					{
						ReactElement:
						(
							<div className="c-data-row__lone-icon c-data-row__picture">
								<Image className="c-data-row__picture-img"
									src={ value } />
								{ link }
							</div>
						),
						item_className: 'logo'
					};
				}
				else
				{
					let displayed_value = value;

					if (typeof value === 'string' && value.indexOf('\t') !== -1)
					{
						displayed_value = [];

						let chunks = value.split('\t');

						chunks.forEach(function (chunk, index)
						{
							if (index < chunks.length && chunk)
							{
								displayed_value.push
								(
									<span key={ displayed_value.length }
										className="c-data-row__tab"></span>
								);
							}

							if (chunk)
							{
								displayed_value.push
								(
									<span key={ displayed_value.length }>{ chunk }</span>
								);
							}
						});
					}

					let link;

					if (config.row_link_base)
					{
						link =
						(
							<Link key={ 1 } className="u-link-only"
								target={ config.prevent_blank ? undefined : '_blank' }
								href={ config.row_link_base + element.id } />
						);
					}
					else if (config.onClick instanceof Function)
					{
						link =
						(
							<button key={ 1 } className="u-link-only"
								onClick={ function (e) { config.onClick(e, element); } }></button>
						);
					}

					data[column] =
					{
						ReactElement:
						[
							<span key={ 0 } className="u-flex">{ displayed_value }</span>,

							link
						]
					}
				}
			});

			var output =
			(
				<DataRow displayed_fields={ displayed_fields } data={ data }
					parity={ i } key={ element.id } clickable={ true }
					version={ 3 } model-config={ config }
				/>
			);

			return output;
		});

		var creation_btn;

		if (config.creation_label)
		{
			creation_btn =
			(
				<Link className="c-btn c-btn--add u-no-margin-top"
					href={ config.creation_link }>
					{ config.creation_label }
				</Link>
			);
		}

		if (props.add_btn === false)
		{
			creation_btn = undefined;
		}

		var actions =
		(
			<div className="datalist-head">

				<SearchBar hide_btn={ true } placeholder="Recherche..."
					data={ autocomplete_data }
					handleChange={ component.handleSearch }
					value={ component.state.searched.value }
				/>

				{ props['custom-filters'] }

				{ creation_btn }

			</div>
		);

		if (props.hide_search === true && creation_btn)
		{
			actions =
			(
				<div className="o-grid-2 u-negative-margin u-content-end">
					{ creation_btn }
				</div>
			);
		}
		else if (props.hide_search === true && !creation_btn)
		{
			actions = undefined;
		}

		var output =
		(
			<div className={ (props.type || props.config.model) + '-datalist' }>

				{ actions }

				<div className="c-title c-title--link">
					<h2 className="c-title__txt">{ config.title }</h2>
					<Link className="u-link-only" href={ config.link } />
				</div>

				<div className="table-container">

					<div className="c-table">
						<DataHeader sortable_cols={ config.sortable_cols }
							onSort={ component.handleSort }
							displayed_fields={ displayed_fields }
							header_map={ config.header_map }
							version={ 3 }
							sort_field={ state.sort_field }
							sort_order={ state.sort_order }
						/>

						{ loader ? undefined : data }
					</div>

					{ loader }

				</div>

				<div className="c-pagination u-margin-top-15">
					{ pagination }
				</div>

			</div>
		);

		return output;
	}
}